import { createMuiTheme } from '@material-ui/core/styles'

export const darkTheme = createMuiTheme({
  palette: {
    type: 'dark',
    background: {
      default: '#343a40',
      paper: '#474f58'
    }
  },
  typography: {
    h1: {
      fontSize: '2.4rem'
    },
    h2: {
      fontSize: '2.1rem'
    },
    h3: {
      fontSize: '1.8rem'
    },
    h4: {
      fontSize: '1.5rem'
    },
    h5: {
      fontSize: '1.2rem'
    }
  },
  overrides: {
    MuiButton: {
      root: {
        fontSize: '1rem',
        '&$outlined': {
          borderBottomColor: '#7986cb'
        }
      }
    }
  },
  app: {
    panelWidth: 360
  }
})
